import DefaultTemplate from './DefaultTemplate';

export { type DefaultTemplateProps } from './DefaultTemplate';
export default DefaultTemplate;
